import { CaseState } from "../types/caseState";
import { apiUrl } from "./base";

export async function extractFields(
  text: string,
  contactType: string
): Promise<CaseState> {
  const res = await fetch(
    apiUrl("/api/extractFields"),
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ text, contactType }),
    }
  );
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}
